import { render, staticRenderFns } from "./VVersionInfo.vue?vue&type=template&id=1d12cefa&scoped=true&"
import script from "./VVersionInfo.vue?vue&type=script&lang=js&"
export * from "./VVersionInfo.vue?vue&type=script&lang=js&"
import style0 from "./VVersionInfo.vue?vue&type=style&index=0&id=1d12cefa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d12cefa",
  null
  
)

export default component.exports